module.exports = __webpack_public_path__ + "img/6.50c689fd.jpg";